export default __webpack_public_path__ + "static/media/leptopFix.df9374b5.jpg";